import React  from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { oAuthSignIn } from 'actions/oauth-sign-in';
import LoaderButton from 'components/LoaderButton';
import ActionExitToApp from 'material-ui-icons/ExitToApp';

class OAuthSignInButton extends React.Component {
  static propTypes = {
    provider: PropTypes.string.isRequired,
    label: PropTypes.string,
    signInParams: PropTypes.object,
    children: PropTypes.node,
    icon: PropTypes.func
  };

  static defaultProps = {
    signInParams: {},
    children: <span>OAuth Sign In</span>,
    icon: ActionExitToApp
  };

  getEndpoint = () => {
    return (
      this.props.endpoint ||
      this.props.auth.getIn(['configure', 'currentEndpointKey']) ||
      this.props.auth.getIn(['configure', 'defaultEndpointKey'])
    );
  }

  handleClick = () => {
    this.props.dispatch(
      oAuthSignIn({
        provider: this.props.provider,
        params: this.props.signInParams,
        endpointKey: this.getEndpoint()
      })
    )
      .then(this.props.next)
      .catch(() => {});
  }

  render = () => {
    let disabled = this.props.auth.getIn(['user', 'isSignedIn']);
    let loading = (
      (this.props.auth.getIn(['ui', 'oAuthSignInLoadingProvider']) === this.props.provider) &&
      this.props.auth.getIn(['oAuthSignIn', this.getEndpoint(), 'loading'])
    );

    return (
      <LoaderButton
        loading={loading}
        icon={this.props.icon}
        disabled={disabled}
        onClick={this.handleClick}
        {...this.props}
      />
    );
  }
}

export default connect(({auth}) => ({auth}))(OAuthSignInButton);



// WEBPACK FOOTER //
// ./src/components/OAuthSignInButton/index.js